import React, { useState, useEffect, useContext } from 'react';
import './documents.scss';
import { Button, LoadingScreen } from 'components';
import { LendingContext } from 'context';
import { useNavService } from 'hooks';
import { routes } from 'router';
import { finaliseApiCall, getBannerUrl, TealiumService } from 'services';
import { OmfLogo, BackArrowDark, VodaLendLogoRed } from 'assets';

const REQUIRED_DOCS = [
  'Your green bar coded ID or ID Card',
  '3 months bank statements',
  'Most recent Payslip or Salary Advice',
];

export const Documents = () => {
  const navigate = useNavService();
  const { application } = useContext(LendingContext);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onDocumentsStart(omfOffer, application?.offers?.hashId);
  }, []);

  async function handleSubmit() {
    if (submitting) { return; }

    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onDocumentsSubmit(omfOffer, application?.offers?.hashId);

    setSubmitting(true);
    try {
      const [response, bannerData] = await Promise.all([finaliseApiCall(), getBannerUrl()]);
      if (bannerData?.banner) {
        sessionStorage.setItem('crossSellBanner', JSON.stringify(bannerData.banner));
      }
      if (response?.status < 400) {
        navigate.to(routes.applicationSubmitted);
      } else {
        navigate.to(routes.appFailed);
      }
    } catch {
      navigate.to(routes.appFailed);
    } finally {
      setSubmitting(false);
    }
  }

  if (submitting) {
    return (
      <LoadingScreen
        loadingMessage='Submitting application'
        secondaryMessage='This should only take a moment'
      />
    );
  }

  return (
    <section className='documents-page'>
      <header className='documents-header is-hidden-tablet'>
        <button
          className='documents-header__back'
          onClick={() => navigate.back()}
          aria-label='Go back'
        >
          <img src={BackArrowDark} alt='Back' />
        </button>
        <h1 className='documents-header__title'>Documents</h1>
      </header>

      <header className='documents-desktop-header is-hidden-mobile'>
        <img src={VodaLendLogoRed} alt='VodaLend' className='documents-desktop-header__logo' />
      </header>

      <main className='documents-content'>
        <div className='documents-card'>
          <div className='documents-panel'>
            <h2 className='documents-panel__heading'>Documentation required</h2>

            <p className='documents-panel__text'>
              One of our consultants will contact you in the next 24 hours.
            </p>

            <p className='documents-panel__text'>
              For a quick and easy call, please have the following documents ready to send to us:
            </p>

            <ul className='documents-checklist'>
              {REQUIRED_DOCS.map((doc) => (
                <li key={doc} className='documents-checklist__item'>
                  <span className='documents-checklist__icon' aria-hidden='true' />
                  <span className='documents-checklist__label'>{doc}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className='documents-footer-area'>
          <div className='documents-footer-area__buttons is-hidden-tablet'>
            <Button primary onClick={handleSubmit} className='documents-submit'>
              Submit application
            </Button>
          </div>

          <div className='documents-branding'>
            <img src={OmfLogo} alt='In association with Old Mutual Finance' className='documents-branding__omf-logo' />
          </div>
        </div>
      </main>

      <footer className='documents-desktop-footer is-hidden-mobile'>
        <div className='btn-placeholder'>
          <Button tertiary onClick={() => navigate.back()}>
            Back
          </Button>
        </div>
        <div className='btn-placeholder'>
          <Button primary onClick={handleSubmit}>
            Submit application
          </Button>
        </div>
      </footer>
    </section>
  );
};
